import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService, ScreenService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable, fromEvent } from 'rxjs';
import { takeWhile, debounceTime, map, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as tripFinderActions from '@ibe/store/actions/trip-finder.actions';
import { SearchParameters } from '@ibe/store/states/trip-finder.state';
import { TripFinderService } from '@ibe.services/mocks.tap/trip-finder.service';


@Component({
	selector: 'app-select-theme-modal',
	templateUrl: './select-theme-modal.indra.component.html',
	styleUrls: ['./select-theme-modal.component.scss']
})
export class INDRASelectThemeModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {

	isAlive = true;
	isLoading = true;

	searchCriteria$: Observable<SearchParameters> = this.store.select(fromStore.getTripFinderSearchParameters);
	searchCriteria: SearchParameters = null;

	currentSelectedThemesTotal = 0;
	hasChanges = false;

	selectedThemes = [];

	themes = [
		{
			id: 'adventure',
			icon: 'destinations--adventure',
			label: 'Adventure'
		},
		{
			id: 'beach',
			icon: 'destinations--beach',
			label: 'Beach'
		},
		{
			id: 'culture',
			icon: 'destinations--culture',
			label: 'Culture'
		},
		{
			id: 'family',
			icon: 'destinations--family',
			label: 'Family'
		},
		{
			id: 'golf',
			icon: 'destinations--golf',
			label: 'Golf'
		},
		{
			id: 'nature',
			icon: 'destinations--nature',
			label: 'Nature'
		},
		{
			id: 'nightlife',
			icon: 'destinations--night_life',
			label: 'Nightlife'
		},
		{
			id: 'romance',
			icon: 'destinations--romance',
			label: 'Romance'
		},
		{
			id: 'shopping',
			icon: 'destinations--shopping',
			label: 'Shopping'
		},
		{
			id: 'snow',
			icon: 'destinations--snow',
			label: 'Snow'
		},
		{
			id: 'surf',
			icon: 'destinations--surf',
			label: 'Surf'
		},
		{
			id: 'gastronomy',
			icon: 'destinations--gastronomia',
			label: 'Gastronomy'
		},
		{
			id: 'relax',
			icon: 'destinations--relax',
			label: 'Relax'
		}
	];

	private loading$: Observable<boolean> = this.store.select(fromStore.getUserLoading);
	isMobile$: Observable<boolean> = this.store.select(fromStore.isScreenMobile);
	isMobile: boolean = false;
	private resize$: Observable<number>;

	constructor(protected modalService: ModalService,
		private screen: ScreenService,
		private tfService: TripFinderService,
		private store: Store<fromStore.State>) {
		super(modalService);

		this.isMobile$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isMobile = value;
			});

		this.resize$ = fromEvent(window, 'resize')
			.pipe(
				debounceTime(250),
				map(() => window.innerWidth),
				distinctUntilChanged(),
				startWith(window.innerWidth),
				tap(width => this.screen.setWindowWidth(Number(width)))
			);

		this.searchCriteria$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(param => {
				if (param) {
					this.searchCriteria = param;
					if (this.searchCriteria.theme) {
						this.searchCriteria.theme.forEach(label => {
							let themeObj = this.themes.find(theme => theme.label === label);
							this.selectedThemes.push(themeObj);
						});
					}

					this.currentSelectedThemesTotal = this.selectedThemes.length;
				}
			});
	}

	ngOnInit() {
		this.loading$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.isLoading = value;
		});

		this.resize$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	closeModal() {
		this.modalService.close();
	}

	INDRA_handleSelectThemeClick(index) {
		let value = this.themes[index];
		if (this.selectedThemes.find(theme => theme.label === this.themes[index].label)) {
			this.selectedThemes.splice(this.selectedThemes.indexOf(value), 1);
		} else {
			this.selectedThemes.push(value);
		}

		if (this.currentSelectedThemesTotal === 0 && this.selectedThemes.length === 0) {
			this.hasChanges = false;
		} else {
			this.hasChanges = true;
		}
	}
	
	INDRA_handleConfirmationClick() {
		let themesToStore = [];
		this.selectedThemes.forEach(theme => {
			themesToStore.push(theme.label);
		});

		// ADD to store
		const criteria = Object.assign(new SearchParameters(), this.searchCriteria, { theme: [...themesToStore] });
		this.store.dispatch(new tripFinderActions.PutSearchParameters(criteria));

		this.modalService.close();

		this.tfService.getOffers(criteria);
	}
	
	INDRA_isChecked(label) {
		return this.selectedThemes.find(theme => theme.label === label) !== undefined;
	}

	INDRA_handleResetClick() {
		this.selectedThemes = [];
		this.hasChanges = this.currentSelectedThemesTotal !== 0;
	}
}
